import { IconLineStoreType } from "@kalodata/kds-design-icons";
import { twMerge } from "tailwind-merge";

export type AccountAvatarPlaceholder = "initial" | "store" | "none";

interface AccountAvatarProps {
  imageUrl?: string;
  name?: string;
  size: number;
  /** 无头像时的占位：首字母 / 店铺图标 / 空 */
  placeholder?: AccountAvatarPlaceholder;
  bordered?: boolean;
  className?: string;
}

export const AccountAvatar = ({
  imageUrl,
  name,
  size,
  placeholder = "initial",
  bordered,
  className,
}: AccountAvatarProps) => {
  const renderPlaceholder = () => {
    if (placeholder === "store") {
      return <IconLineStoreType size={Math.round(size * 0.75)} className="text-kds-fg-soft" />;
    }
    if (placeholder === "initial") {
      return (
        <span className="font-medium text-kds-fg-soft" style={{ fontSize: Math.max(10, Math.round(size * 0.5)) }}>
          {(name || "U").slice(0, 1).toUpperCase()}
        </span>
      );
    }
    return null;
  };

  return (
    <div
      className={twMerge(
        "flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-kds-bg-subtle",
        bordered ? "border border-kds-border" : "",
        className,
      )}
      style={{ width: size, height: size }}
    >
      {imageUrl ? (
        <img src={imageUrl} alt={name ?? ""} className="size-full object-cover" loading="lazy" />
      ) : (
        renderPlaceholder()
      )}
    </div>
  );
};
